'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _Field = require('./Field');

var _Field2 = _interopRequireDefault(_Field);

var _validatorjs = require('validatorjs');

var _validatorjs2 = _interopRequireDefault(_validatorjs);

var _immutable = require('immutable');

var _FormRow = require('./FormRow');

var _FormRow2 = _interopRequireDefault(_FormRow);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Form is a component which allows you to create a managed or self-managed form.
 *
 */


// TODO - Can we add a type 'fix' - if its already errored and you change it
var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.state = {
      fields: [],
      fieldOrder: [],
      value: {},
      errors: {}
    };

    _this.defaultWrapper = function (key, element) {
      return React.createElement(
        _FormRow2.default,
        { key: key },
        element
      );
    };

    _this.renderField = function (field, name) {
      // if (React.isValidElement(field)) {
      //     return field;
      // } else {

      var _this$props = _this.props,
          onValidate = _this$props.onValidate,
          onChange = _this$props.onChange;

      var _ref = onValidate ? _this.props : _this.state,
          _ref$errors = _ref.errors,
          errors = _ref$errors === undefined ? {} : _ref$errors;

      var _ref2 = onChange ? _this.props : _this.state,
          value = _ref2.value;

      var type = field.type,
          _field$wrapper = field.wrapper,
          wrapper = _field$wrapper === undefined ? _this.defaultWrapper : _field$wrapper,
          fieldProps = _objectWithoutProperties(field, ['type', 'wrapper']);

      var fieldValue = value ? value[name] : undefined;
      var fieldErrors = errors[name];

      return wrapper(name, React.createElement(_Field2.default, _extends({
        name: name,
        type: type
      }, fieldProps, {
        errors: fieldErrors,
        value: fieldValue,
        onChange: function onChange(val) {
          return _this.handleFieldChange(name, val);
        },
        onBlur: function onBlur(e) {
          return _this.handleValidation(_this.getValue(), name, 'blur');
        }
      })));
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();
      var value = _this.getValue();
      var ok = _this.handleValidation(value, undefined, 'submit');
      ok && _this.props.onSubmit && _this.props.onSubmit(value);
    };

    if (!props.onChange) {
      // IF the form is internally managed, initialise fields to empty strings to
      // prevent warning about unmanaged fields becoming managed
      var names = (0, _lodash.map)(props.fields, function (value, name) {
        return value.name || name;
      });
      _this.state.value = (0, _lodash.reduce)(names, function (result, name) {
        result[name] = '';
        return result;
      }, {});
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.orderFields(this.props.fields);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.orderFields(props.fields);
    }
  }, {
    key: 'orderFields',
    value: function orderFields() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if ((0, _lodash.isArray)(fields)) {
        var fieldsObj = (0, _lodash.reduce)(fields, function (result, field) {
          return _extends({}, result, _defineProperty({}, field.name, field));
        }, {});
        var _fieldOrder = (0, _lodash.map)(fields, 'name');
        this.setState({ fields: fieldsObj, fieldOrder: _fieldOrder });
      } else {
        this.setState({ fields: fields, fieldOrder: (0, _lodash.keys)(fields) });
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      var _props = this.props,
          onValidate = _props.onValidate,
          onChange = _props.onChange;

      var _ref3 = onChange ? this.props : this.state,
          value = _ref3.value;

      return value;
    }
  }, {
    key: 'hasValidateOn',
    value: function hasValidateOn(validateOn, actionType) {
      return validateOn.indexOf(actionType) >= 0;
    }
  }, {
    key: 'shouldValidate',
    value: function shouldValidate(currentField, actionType, fieldName) {
      var _find = (0, _lodash.find)(this.state.fields, {
        name: fieldName
      }),
          _find$validateOn = _find.validateOn,
          validateOn = _find$validateOn === undefined ? 'blur,submit' : _find$validateOn;
      // always validate when 'always' set


      if (this.hasValidateOn(validateOn, 'always')) {
        return true;
      }
      // validate if its the current field and the actionType is matched or if we're
      // submitting
      if (fieldName === currentField || actionType === 'submit') {
        return this.hasValidateOn(validateOn, actionType);
      }
      // if validateOn contains the current field, update

      if (currentField && this.hasValidateOn(validateOn, currentField)) {
        return true;
      }
    }
  }, {
    key: 'handleValidation',
    value: function handleValidation(data, fieldName, type) {
      var _this2 = this;

      var _state$fields = this.state.fields,
          fields = _state$fields === undefined ? {} : _state$fields;

      var rules = (0, _immutable.Map)(fields).map(function (field, name) {
        return field.validation;
      }).filter(function (rule, name) {
        return rule;
      }).filter(function (rule, name) {
        return _this2.shouldValidate(fieldName, type, name);
      });

      var messages = (0, _immutable.Map)(fields).filter(function (field, name) {
        return field.errors;
      }).flatMap(function (field, name) {
        return (0, _immutable.Map)(field.errors).mapEntries(function (entry) {
          return [entry[0] + '.' + name, entry[1]];
        });
      }).filter(function (message, key) {
        return message;
      });

      if (!rules.count()) {
        return true;
      }
      var validation = new _validatorjs2.default(data, rules.toObject(), messages.toObject());
      // Run the validation
      validation.fails();
      var errors = (0, _immutable.Map)(rules).map(function (value, name) {
        return validation.errors.get(name) || [];
      }).toObject();

      var onValidate = this.props.onValidate;

      if (onValidate) {
        return onValidate(errors);
      } else {
        this.setState({ errors: (0, _lodash.assign)({}, this.state.errors, errors) });
        console.log('Errors ', errors);
        return !(0, _lodash.some)(errors, function (value) {
          return value.length;
        });
      }
    }
  }, {
    key: 'handleFieldChange',
    value: function handleFieldChange(field, value) {
      // checkboxes don't use value - they use 'checked' because FU react.
      var newValue = (0, _immutable.Map)(this.getValue()).set(field, value).toJS();
      this.handleValidation(newValue, field, 'change');
      var onChange = this.props.onChange;

      if (onChange) {
        onChange(newValue);
      } else {
        this.setState({ value: newValue });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          _props2$className = _props2.className,
          className = _props2$className === undefined ? '' : _props2$className,
          children = _props2.children,
          errors = _props2.errors,
          value = _props2.value,
          onValidate = _props2.onValidate,
          onChange = _props2.onChange,
          props = _objectWithoutProperties(_props2, ['className', 'children', 'errors', 'value', 'onValidate', 'onChange']);

      var _state = this.state,
          fields = _state.fields,
          fieldOrder = _state.fieldOrder;


      return React.createElement(
        'form',
        _extends({
          noValidate: true
        }, (0, _lodash.omit)(props, ['fields']), {
          className: 'Form ' + className,
          onSubmit: this.handleSubmit
        }),
        (0, _lodash.map)(fieldOrder, function (name) {
          return _this3.renderField(fields[name], name);
        }),
        children
      );
    }
  }]);

  return Form;
}(React.Component);

exports.default = Form;